// Use the theme's close animation, without collapsing fixed desktop/contact blocks.
// Delegation also handles footer sections re-rendered in the theme editor.
document.addEventListener('theme:collapsible:toggle', (event) => {
  const opened = event.target;
  if (!(opened instanceof Element) || !opened.matches('[data-collapsible][open="true"]:not([disabled])')) return;

  const footer = opened.closest('collapsible-elements[data-footer-single-open]');
  if (!footer || typeof footer.close !== 'function') return;

  footer.querySelectorAll('[data-collapsible][open="true"]:not([disabled])').forEach((other) => {
    if (other !== opened) footer.close(other);
  });
});
